import { render, staticRenderFns } from "./ContentSlots.vue?vue&type=template&id=10056885&scoped=true"
import script from "./ContentSlots.vue?vue&type=script&lang=js"
export * from "./ContentSlots.vue?vue&type=script&lang=js"
import style0 from "./ContentSlots.vue?vue&type=style&index=0&id=10056885&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10056885",
  null
  
)

export default component.exports